import { get as _get, throttle } from 'lodash'
import libTrack from '../libTrack'
import { Notification } from 'element-ui'
import { v4 } from 'uuid'
import { setPolling } from '@/util/tools'

const SIZE_1M = 1024 * 1024
const staySessionId = v4()
let memoryNotification

function uploadPerfData() {
  const memoryInfo = performance.memory || { jsHeapSizeLimit: 0, totalJSHeapSize: 0, usedJsHeapSize: 0 }
  // 上下文内可用堆的最大体积
  const limitedJS = Math.round(memoryInfo.jsHeapSizeLimit / SIZE_1M)
  // 已分配的堆体积
  const totalJS = Math.round(memoryInfo.totalJSHeapSize / SIZE_1M)
  // 当前 JS 堆活跃段（segment）的体积
  const usedJS = Math.round(memoryInfo.usedJSHeapSize / SIZE_1M)
  const memoryTip = `最大可用内存 ${limitedJS}M, 已经分配内存 ${totalJS}M, 已经使用内存 ${usedJS}M`

  const nodeNumber = document.querySelectorAll('*').length
  const nodeTip = `节点数量： ${nodeNumber}`

  const stayTime = Math.round(performance.now() / 1000 / 60)
  const stayTip = `停留时长： ${stayTime}分钟`

  const biz_tag = getWorkbenchDesc()

  console.log('上报性能数据: ', memoryTip, nodeTip, stayTip)
  libTrack.trace('上报性能数据: ' + [memoryTip, nodeTip, stayTip, location.href].join(', '))
  libTrack.view('__perf_crm_h5newcallcenter', {
    stayTime,
    nodeNumber,
    limitedJS,
    totalJS,
    usedJS,
    staySessionId
  })

  libTrack.monitor({
    category: 'custom',
    metric: {
      type: 'Gauge',
      value: Math.ceil((usedJS / limitedJS) * 100),
      name: 'business.crm.memory_log',
      tags: {
        run_time: stayTime,
        apm_version: '0.0.1',
        app_foreground: document.hidden ? 0 : 1,
        memory_log_type: 0,
        biz_tag,
        page_id: libTrack.pageNameHandler(window.location.href),
        stayTime,
        nodeNumber,
        limitedJS,
        totalJS,
        usedJS,
        userId: window.lib?.track?.trackModel?.userId,
        staySessionId
      },
      sections: {
        device_total_memory: limitedJS, // 设备总内存
        available_memory: usedJS, // 当前设备可用内存
        available_memory_percent: Math.round((usedJS / limitedJS) * 100), // 当前设备可用内存百分比
        native_memory_free: limitedJS - usedJS, // 当前app native内存分配
        stayTime: stayTime
      }
    },
    attrs: {
      device_total_memory: limitedJS, // 设备总内存
      available_memory: usedJS, // 当前设备可用内存
      available_memory_percent: Math.round((usedJS / limitedJS) * 100), // 当前设备可用内存百分比
      native_memory_free: limitedJS - usedJS, // 当前app native内存分配
      stayTime: stayTime
    },
    ext: {
      stayTime,
      nodeNumber,
      limitedJS,
      totalJS,
      usedJS,
      biz_tag,
      staySessionId
    }
  })

  // 内存占用过高，建议刷新页面
  if (usedJS / limitedJS > 0.9 && isSupportWarningNotice()) {
    memoryNotification && memoryNotification.close && memoryNotification.close()
    memoryNotification = Notification({
      type: 'warning',
      title: '提示',
      duration: 0,
      message: getWorkbenchNotice()
    })
    libTrack.view('memoryNotification', {
      stayTime,
      nodeNumber,
      limitedJS,
      totalJS,
      usedJS
    })
  }
}

// 是否支持告警提醒
function isSupportWarningNotice() {
  if ((location.hash || '').includes('#/tr_callin')) return true
  if ((location.hash || '').includes('#/callin/')) return true
  if ((location.hash || '').includes('#/im')) return true
  if ((location.hash || '').includes('#/crmcall')) return true
  if ((location.hash || '').includes('#/region-callin')) return true
  if ((location.hash || '').includes('#/callin-workbench')) return true
  return false
}

// 获取工作台类型
function getWorkbenchDesc() {
  if ((location.hash || '').includes('#/tr_callin')) return 'tr_callin'
  if ((location.hash || '').includes('#/callin/')) return 'callin'
  if ((location.hash || '').includes('#/im')) return 'im'
  if ((location.hash || '').includes('#/crmcall')) return 'crmcall'
  if ((location.hash || '').includes('#/region-callin')) return 'regionCallin'
  if ((location.hash || '').includes('#/callin-workbench')) return 'callinWorkbench'
  return 'normal'
}

function getWorkbenchNotice() {
  if ((location.hash || '').includes('#/tr_callin'))
    return '当前页面占用资源过多，为避免出现页面崩溃，建议您重启浏览器后使用。（请先挂断电话,并设置座席为离线后重启浏览器）'
  if ((location.hash || '').includes('#/callin/'))
    return '当前页面占用资源过多，为避免出现页面崩溃，建议您重启浏览器后使用。（请先挂断电话,并设置座席为离线后重启浏览器）'
  if ((location.hash || '').includes('#/crmcall'))
    return '当前页面占用资源过多，为避免出现页面崩溃，建议您重启浏览器后使用。（请先挂断电话,并设置座席为离线后重启浏览器）'
  return '当前页面占用资源过多，为避免出现页面崩溃，建议您重启浏览器后使用。'
}

function addNoopenerToATag() {
  try {
    const aList = Array.from(document.querySelectorAll('a')).filter(a => {
      // JS 链接，或者已经有了 noopener 参数的不需要再新增标志
      return !(a.href.startsWith('javascript:') || (a.rel && a.rel.includes('noopener')))
    })

    aList.forEach(a => {
      const modifiedRel = a.rel ? a.rel + ',noopener' : 'noopener'
      a.rel = modifiedRel
    })
  } catch (e) {
    console.error('addNoopenerToATag error', e)
  }
}

function blockWindowOpener() {
  // 拦截 window.open 方法，增加 noopener 参数
  // 保存原始的 window.open 方法的引用
  const originalWindowOpen = window.open

  // 重写 window.open 方法
  window.open = function(url, target, features) {
    // 在 features 参数中添加 noopener
    const modifiedFeatures = features ? features + ',noopener' : 'noopener'

    // 调用原始的 window.open 方法，并传递修改后的参数
    return originalWindowOpen.call(this, url, target, modifiedFeatures)
  }

  // 观察 Dom 变化，给所有 A 标签增加 noopener 参数
  addNoopenerToATag()
  // 创建一个 MutationObserver 实例
  const observer = new MutationObserver(throttle(addNoopenerToATag, 600))

  // 配置观察选项
  const config = { attributes: true, childList: true, subtree: true }

  // 开始观察全局 DOM
  observer.observe(document.documentElement, config)
  // 停止观察
  // observer.disconnect();
  return observer
}
let timer = null
let blockObserver = null

export function beforeAppCreate() {
  try {
    timer = setPolling(
      () => {
        try {
          uploadPerfData()
        } catch (e) {
          console.log('性能监控上报失败', e)
        }
      },
      60 * 1000,
      { ignoreBackgrounder: true, from: '性能监控上报轮循' }
    )
    uploadPerfData()
    setTimeout(() => {
      blockObserver = blockWindowOpener()
    }, 1000)
  } catch (e) {
    console.log('性能监控初始化失败', e)
  }
}

function destroy(e) {
  if (timer) {
    timer?.clear?.()
    timer = null
  }
  if (blockObserver) {
    blockObserver.disconnect()
    blockObserver = null
  }
  window.removeEventListener('beforeunload', destroy)
  // e.preventDefault()
  // e.returnValue = true
}
window.addEventListener('beforeunload', destroy)
